import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import EditProduct from "./pages/EditProduct";
import AddProduct from "./pages/AddProduct";
import OrderEdit from "./pages/OrderEdit";
import Orders from "./pages/Orders";
import SignIn from "./pages/SignIn";
import { useContext } from "react";
import { AuthContext } from "./contexts/AuthContext";
import Profile from "./pages/Profile";
import TimeLine from "./pages/TimeLine";
import Categories from "./pages/Categories";
import Banners from "./pages/Banners";
import SiteContent from "./pages/SiteContent";
import LongDescriptions from "./pages/LongDescriptions";
import Campaigns from "./pages/Campaigns";
import ProductImages from "./pages/ProductImages";
import ProductImagesDetail from "./pages/ProductImagesDetail";
import SeoSettings from "./pages/SeoSettings";
import BlogPosts from "./pages/BlogPosts";

function App() {
  const { profile } = useContext(AuthContext);
  return (
    <Routes>
      <Route path="/" element={profile ? <Home /> : <Navigate to="/sign-in" />} />
      <Route path="/products" element={profile ? <Products /> : <Navigate to="/sign-in" />} />
      <Route path="/orders" element={profile ? <Orders /> : <Navigate to="/sign-in" />} />
      <Route path="/edit-product/:SKU" element={profile ? <EditProduct /> : <Navigate to="/sign-in" />} />
      <Route path="/edit-order/:ID" element={profile ? <OrderEdit /> : <Navigate to="/sign-in" />} />
      <Route path="/add-product" element={profile ? <AddProduct /> : <Navigate to="/sign-in" />} />
      <Route path="/sign-in" element={profile ? <Navigate to="/profile" /> : <SignIn />} />
      <Route path="/profile" element={profile ? <Profile /> : <Navigate to="/sign-in" />} />
      <Route path="/timeline" element={profile ? <TimeLine /> : <Navigate to="/sign-in" />} />
      <Route path="/categories" element={profile ? <Categories /> : <Navigate to="/sign-in" />} />
      <Route path="/banners" element={profile ? <Banners /> : <Navigate to="/sign-in" />} />
      <Route path="/site-content" element={profile ? <SiteContent /> : <Navigate to="/sign-in" />} />
      <Route path="/long-descriptions" element={profile ? <LongDescriptions /> : <Navigate to="/sign-in" />} />
      <Route path="/campaigns" element={profile ? <Campaigns /> : <Navigate to="/sign-in" />} />
      <Route path="/product-images" element={profile ? <ProductImages /> : <Navigate to="/sign-in" />} />
      <Route path="/product-images/:sku" element={profile ? <ProductImagesDetail /> : <Navigate to="/sign-in" />} />
      <Route path="/seo-settings" element={profile ? <SeoSettings /> : <Navigate to="/sign-in" />} />
      <Route path="/blog-posts" element={profile ? <BlogPosts /> : <Navigate to="/sign-in" />} />
    </Routes>
  );
}

export default App;
